import React, { FC, useContext } from "react";
import { defineMessages, useIntl } from "react-intl";
import { UserContext } from "@app/provider";
import { routes } from "@app/routing";
import { SentEmailAfterUnlockView } from "@app/components";

export interface CredentialsInterface {
  email: string;
  dateOfBirth?: string;
  lastName?: string;
}

const messages = defineMessages({
  unlockedViewFooter: {
    id: "unlockedViewFooter",
    defaultMessage:
      "Didn’t receive the email? Please check whether you spelled your email correctly, and entered the correct last name and date of birth on the previous screen. Codes are not sent to incorrectly spelled email addresses, and are not sent when information entered does not match what your clinic provided.",
  },
});

interface UnlockedViewProps {
  email: string;
  credentials?: CredentialsInterface;
}

export const UnlockedView: FC<UnlockedViewProps> = ({ email }) => {
  const intl = useIntl();
  const { isLoading, clearUnlockUserData } = useContext(UserContext);

  return (
    <SentEmailAfterUnlockView
      email={email}
      isLoading={isLoading}
      backLink={routes.unlock}
      handleBack={clearUnlockUserData}
      footerOverride={<p>{intl.formatMessage(messages.unlockedViewFooter)}</p>}
    />
  );
};

export default UnlockedView;
